import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../postModal/css/BottomContainer.module.css";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { styled } from "@mui/material/styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import eventStyles from "./EventModal.module.css";
import DoneButton from "../shared/ui/Modal/DoneButton";
import ModalTextfield from "../shared/ui/Modal/ModalTextfield";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationModal from "../LocationModal/LocationModal";

const GoogleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const time = [
  "12:00",
  "12:30",
  "1:00",
  "1:30",
  "2:00",
  "2:30",
  "3:00",
  "3:30",
  "4:00",
  "4:30",
  "5:00",
  "5:30",
  "6:00",
  "6:30",
  "7:00",
  "7:30",
  "8:00",
  "8:30",
  "9:00",
  "9:30",
  "10:00",
  "10:30",
  "11:00",
  "11.30",
];

const timezoneList = [
  "(UTC-12:00) International Date Line West",
  "(UTC-11:00) Midway Island Samoa",
  "(UTC-10:00) Hawaii",
  "(UTC-09:30) Marquesas Islands",
  "(UTC-09:00) Aleutian Islands",
  "(UTC-08:00) Alaska",
  "(UTC-08:00) Picairn Islands",
  "(UTC-07:00) Pacific Time (US and Canada), Tijuana",
  "(UTC-07:00) Arizona",
  "(UTC-06:00) Mountain Time (US and Canada)",
  "(UTC-06:00) Chihuahua, La Paz, Mazatlan",
  "(UTC-06:00) Saskatchewan",
  "(UTC-06:00) Central America",
  "(UTC-05:00) Central Time (US and Canada)",
  "(UTC-05:00) Bogota, Lima, Quito",
  "(UTC-04:00) Eastern Time (US and Canada)",
  "(UTC-04:00) Indiana (East)",
  "(UTC-04:00) Caracas, La Paz",
  "(UTC-04:00) Santiago",
  "(UTC-03:00) Atlantic Time (Canada)",
  "(UTC-03:00) Brasilia",
  "(UTC-03:00) Buenos Aires, Georgetown",
  "(UTC-02:30) Newfoundland and Labrador",
  "(UTC-02:00) Greenland",
  "(UTC-02:00) Mid-Atlantic",
  "(UTC-01:00) Cape Verde Islands",
  "(UTC+00:00) Azores",
  "(UTC+00:00) Coordinated Universal Time",
  "(UTC+00:00) Reykjavik",
  "(UTC+01:00) Dublin, Edinburgh, Lisbon, London",
  "(UTC+01:00) Casablanca, Monrovia",
  "(UTC+01:00) West Central Africa",
  "(UTC+02:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  "(UTC+02:00) Sarajevo, Skopje, Warsaw, Zagreb",
  "(UTC+02:00) Brussels, Copenhagen, Madrid, Paris",
  "(UTC+02:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  "(UTC+02:00) Cairo",
  "(UTC+02:00) Harare, Pretoria",
  "(UTC+03:00) Bucharest",
  "(UTC+03:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
  "(UTC+03:00) Athens, Istanbul, Minsk",
  "(UTC+03:00) Jerusalem",
  "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
  "(UTC+03:00) Kuwait, Riyadh",
  "(UTC+03:00) Nairobi",
  "(UTC+03:00) Baghdad",
  "(UTC+04:00) Abu Dhabi, Muscat",
  "(UTC+04:00) Baku, Tbilisi, Yerevan",
  "(UTC+04:30) Tehran",
  "(UTC+04:30) Kabul",
  "(UTC+05:00) Ekaterinburg",
  "(UTC+05:00) Islamabad, Karachi, Tashkent",
  "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  "(UTC+05:30) Sri Jayawardenepura",
  "(UTC+05:45) Kathmandu",
  "(UTC+06:00) Astana, Dhaka",
  "(UTC+06:00) Almaty, Novosibirsk",
  "(UTC+06:30) Yangon Rangoon",
  "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  "(UTC+07:00) Krasnoyarsk",
  "(UTC+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi",
  "(UTC+08:00) Kuala Lumpur, Singapore",
  "(UTC+08:00) Taipei",
  "(UTC+08:00) Western Australia",
  "(UTC+08:00) Irkutsk, Ulaanbaatar",
  "(UTC+08:45) Western Australia (Eucla)",
  "(UTC+09:00) Seoul",
  "(UTC+09:00) Osaka, Sapporo, Tokyo",
  "(UTC+09:00) Yakutsk",
  "(UTC+09:30) Darwin",
  "(UTC+09:30) Adelaide",
  "(UTC+10:00) Canberra, Melbourne, Sydney",
  "(UTC+10:00) Brisbane",
  "(UTC+10:00) Hobart",
  "(UTC+10:00) Vladivostok",
  "(UTC+10:00) Guam, Port Moresby",
  "(UTC+10:30) Lord Howe",
  "(UTC+11:00) Magadan, Solomon Islands, New Caledonia",
  "(UTC+11:00) Norfolk Island",
  "(UTC+12:00) Fiji Islands, Kamchatka, Marshall Islands",
  "(UTC+12:00) Auckland, Wellington",
  "(UTC+12:00) Tarawa",
  "(UTC+12:45) Chatham Islands",
  "(UTC+13:00) Nuku'alofa",
  "(UTC+14:00) Kiritimati",
];

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const CustomSelectTime = ({ text, value, change }) => {
  return (
    <>
      <Typography
        sx={{
          fontSize: "14px",
          color: "primary.black",
          mt: 2,
        }}
      >
        {text}
      </Typography>
      <FormControl fullWidth margin="normal" sx={{ mt: 1 }}>
        <Select
          value={value}
          onChange={(e) => change(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-input": {
              padding: "5px 14px",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "secondary.main",
            },
          }}
          MenuProps={{
            sx: {
              "&& .Mui-selected": {
                backgroundColor: "rgba(0,116,228,0.08)",
              },
            },
          }}
        >
          {time.map((item) => (
            <MenuItem
              value={`${item} AM`}
              sx={{
                "&.MuiMenuItem-root .Mui-selected": {
                  backgroundColor: "rgba(0,116,228,0.08)",
                },
              }}
            >
              {`${item} AM`}
            </MenuItem>
          ))}
          {time.map((item) => (
            <MenuItem
              value={`${item} PM`}
              sx={{
                "&.MuiMenuItem-root .Mui-selected": {
                  backgroundColor: "rgba(0,116,228,0.08)",
                },
              }}
            >
              {`${item} PM`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

const EventModal = ({
  show,
  closeModal,
  fileInput,
  pic,
  updateValueMessage,
  updateEventPost,
  updateCoordinates,
  eventPost,
}) => {
  const addressLocal = JSON.parse(localStorage.getItem("address")) ?? "";
  const lat = JSON.parse(localStorage.getItem("lat"));
  const lng = JSON.parse(localStorage.getItem("lng"));
  const [eventType, setEventType] = useState(
    (eventPost?.event_type === "INPERSON" ? "in-person" : "online") ||
      "in-person"
  );
  const [eventName, setEventName] = useState(eventPost?.name || "");
  const [timezone, setTimezone] = useState(
    eventPost?.timezone || "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"
  );
  const [startDate, setStartDate] = useState(null);
  const [startTime, setStartTime] = useState(
    eventPost?.start_date_time?.slice(12, 20) || ""
  );
  const [addEndDate, setAddEndDate] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [endTime, setEndTime] = useState(
    eventPost?.end_date_time?.slice(12, 20) || ""
  );
  const [externalEventLink, setExternalEventLink] = useState(
    eventPost?.event_link || ""
  );
  const [description, setDescription] = useState(
    eventPost?.event_description || ""
  );
  const [address, setAddress] = useState(eventPost?.address || addressLocal);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [isFree, setIsFree] = useState(eventPost?.free || true);
  const [price, setPrice] = useState(eventPost?.price || "");
  const [discountedPrice, setDiscountedPrice] = useState(
    eventPost?.discountedPrice || ""
  );
  const { t } = useTranslation();

  const [coordinates, setCoordinates] = useState({
    lat: lat,
    lng: lng,
  });

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 21,
    height: 21,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto #0074E4",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#0074E4",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 21,
      height: 21,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#0267C8",
    },
  });

  // Inspired by blueprintjs
  function BpRadio(props) {
    return (
      <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleAddEndDateChange = () => {
    setAddEndDate(!addEndDate);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    updateEventPost({
      event_type: eventType === "in-person" ? "INPERSON" : "ONLINE",
      name: eventName,
      address: address,
      free: isFree,
      event_link: externalEventLink,
      event_description: description,
      start_date_time: `${startDate?.toString()?.slice(4, 15)},${startTime}`,
      end_date_time: `${endDate?.toString()?.slice(4, 15)},${endTime}`,
      timezone: timezone,
      price: price,
      discountedPrice: discountedPrice,
    });
    updateCoordinates({
      lat: coordinates.lat,
      lng: coordinates.lng,
      address: address,
    });
    closeModal();
  };

  const handleAddress = (add) => {
    setAddress(add);
  };

  const handleCoordinatesChange = (coor) => {
    setCoordinates(coor);
  };

  console.log(startDate);

  return (
    <>
      <LocationModal
        show={showLocationModal}
        closeModal={() => setShowLocationModal(false)}
        method={handleAddress}
        coordinates={coordinates}
        setCoordinates={handleCoordinatesChange}
      />
      <Box
        sx={{
          background: "#fff",
          borderRadius: "0px 0px 15px 15px",
        }}
      >
        <Divider sx={{ background: "rgba(0,0,0,0.08)" }} />
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              maxHeight: "65vh",
              overflowY: "scroll",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              overflowX: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {pic === null ? (
                <Box
                  sx={{
                    background: "#f2f8fc",
                    position: "relative",
                    maxHeight: "40vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <input
                    onChange={(e) => fileInput(e)}
                    type="file"
                    accept="image/*"
                    className={styles.fileUpload}
                  />
                  <img
                    src="/Image/DashboardImages/postModImages/event-post.png"
                    alt="event cover"
                    style={{ objectFit: "contain", height: "40vh" }}
                  />
                  <Button
                    disableRipple
                    sx={{
                      background: "#ef476f",
                      ":hover": {
                        background: "#ef476f",
                      },

                      textTransform: "none",
                      color: "#fff",
                      borderRadius: "12px",
                      px: 2,
                      "& .MuiButton-startIcon": { marginRight: "7px" },
                    }}
                    startIcon={
                      <Avatar
                        variant="square"
                        src="/Image/DashboardImages/postModImages/add_post_icon.svg"
                        sx={{ color: "#fff", width: "auto", height: "18px" }}
                      />
                    }
                  >
                    <input
                      onChange={(e) => fileInput(e)}
                      type="file"
                      accept="image/*"
                      className={styles.fileUpload}
                    />
                    Upload Picture
                  </Button>
                </Box>
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={pic}
                    alt="pictureEvent"
                    style={{ objectFit: "contain", height: "40vh" }}
                  />
                </Box>
              )}
            </Box>

            <Box sx={{ padding: "20px 25px", width: "90%" }}>
              <Typography sx={{ fontSize: "14px", color: "primary.black" }}>
                {t("eventModal.eventtype")}
              </Typography>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  row
                  aria-label="event-type"
                  name="event-type"
                  value={eventType}
                  onChange={(e) => setEventType(e.target.value)}
                >
                  <FormControlLabel
                    value="in-person"
                    control={<BpRadio />}
                    label={t("eventModal.inperson")}
                    sx={{ fontSize: "14px", color: "primary.black" }}
                  />
                  <FormControlLabel
                    value="online"
                    control={<BpRadio />}
                    label={t("eventModal.online")}
                    sx={{ fontSize: "14px", ml: 1, color: "primary.black" }}
                  />
                </RadioGroup>
              </FormControl>
              <Typography
                sx={{ fontSize: "14px", color: "primary.black", mt: 2 }}
              >
                {t("eventModal.eventname")}*
              </Typography>
              <ModalTextfield value={eventName} setValue={setEventName} />
              <Typography
                sx={{ fontSize: "14px", color: "primary.black", mt: 2 }}
              >
                {t("eventModal.timezone")}*
              </Typography>
              <FormControl fullWidth margin="normal" sx={{ mt: 1 }}>
                <Select
                  value={timezone}
                  onChange={(e) => setTimezone(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      padding: "5px 14px",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "secondary.main",
                    },
                  }}
                  MenuProps={{
                    sx: {
                      "&& .Mui-selected": {
                        backgroundColor: "rgba(0,116,228,0.08)",
                      },
                    },
                  }}
                >
                  {timezoneList.map((zone, idx) => (
                    <MenuItem
                      key={idx}
                      value={zone}
                      sx={{
                        "&.MuiMenuItem-root .Mui-selected": {
                          backgroundColor: "rgba(0,116,228,0.08)",
                        },
                      }}
                    >
                      {zone}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Grid container spacing={4}>
                <Grid item md={6}>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "primary.black",
                      mt: 2,
                      mb: 1.2,
                    }}
                  >
                    {t("eventModal.startdate")}*
                  </Typography>

                  <DatePicker
                    wrapperClassName={eventStyles.datePicker}
                    selected={startDate}
                    onChange={handleStartDateChange}
                  />
                </Grid>
                <Grid item md={6}>
                  <CustomSelectTime
                    text={t("eventModal.starttime")}
                    value={startTime}
                    change={setStartTime}
                  />
                </Grid>
              </Grid>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={addEndDate}
                    onChange={handleAddEndDateChange}
                  />
                }
                label={t("eventModal.addenddate")}
              />

              {addEndDate && (
                <Grid container spacing={4}>
                  <Grid item md={6}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "primary.black",
                        mt: 2,
                        mb: 1.2,
                      }}
                    >
                      {t("eventModal.enddate")}
                    </Typography>
                    <DatePicker
                      wrapperClassName={eventStyles.datePicker}
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </Grid>

                  <Grid item md={6}>
                    <CustomSelectTime
                      text={t("eventModal.endtime")}
                      value={endTime}
                      change={setEndTime}
                    />
                  </Grid>
                </Grid>
              )}

              {eventType == "in-person" && (
                <>
                  <Typography
                    sx={{ fontSize: "14px", color: "primary.black", mt: 2 }}
                  >
                    {t("eventModal.address")}*
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Chip
                      icon={<LocationOnIcon color="#000" />}
                      label={
                        address
                          ? `${address?.slice(0, 37)}...`
                          : "Select a location"
                      }
                      sx={{
                        mt: 1,
                        color: "#000",
                        fontSize: "15px",
                        fontWeight: 600,
                        lineHeight: "20px",
                      }}
                    />
                    <Button
                      onClick={() => setShowLocationModal(true)}
                      disableRipple
                      sx={{
                        ml: 1,
                        mt: 1,
                        ":hover": {
                          background: "none",
                        },
                        color: "#007A85",
                        fontSize: "15px",
                        fontWeight: 600,
                        lineHeight: "20px",
                        textTransform: "none",
                      }}
                    >
                      Edit
                    </Button>
                  </Box>

                  <Box>
                    <img
                      src={`https://maps.googleapis.com/maps/api/staticmap?center=${coordinates.lat},${coordinates.lng}&zoom=17&size=700x200&markers=icon:http://stage-nxnearby-assets.s3.ap-south-1.amazonaws.com/media/static/event.png|${coordinates.lat},${coordinates.lng}&maptype=terrain&key=${GoogleMapsApiKey}&style=feature:administrative.land_parcel%7Celement:geometry.fill%7Cweight:4&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:administrative.locality%7Celement:geometry.fill%7Cweight:5&style=feature:administrative.neighborhood%7Celement:geometry.fill%7Cweight:5.5&style=feature:administrative.province%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:landscape%7Celement:geometry.fill%7Ccolor:0xfcfcfc&style=feature:landscape.natural.landcover%7Celement:geometry.fill%7Ccolor:0xe9f7c4&style=feature:landscape.natural.terrain%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi%7Celement:labels.text.stroke%7Ccolor:0xffffff&style=feature:poi.attraction%7Celement:geometry.fill%7Cweight:5&style=feature:poi.business%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.government%7Celement:geometry.fill%7Ccolor:0xffdfba%7Cweight:4&style=feature:poi.medical%7Celement:geometry.fill%7Cweight:4.5&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xbaffc9&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:poi.place_of_worship%7Cvisibility:off&style=feature:poi.place_of_worship%7Celement:geometry.fill%7Ccolor:0xffb3ba&style=feature:poi.school%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:poi.sports_complex%7Celement:geometry.fill%7Ccolor:0xffdfba&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road%7Celement:geometry.fill%7Clightness:10&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:geometry.fill%7Ccolor:0xe0e0e0%7Clightness:40%7Cweight:5&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:geometry.fill%7Ccolor:0xc0faff&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e`}
                      style={{ marginTop: 16, borderRadius: 16, width: "95%" }}
                    />
                  </Box>
                </>
              )}

              <FormGroup sx={{ mt: 2 }}>
                <FormControlLabel
                  control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
                  label="Free"
                  onChange={() => setIsFree(!isFree)}
                  value={isFree}
                />
              </FormGroup>

              {!isFree && (
                <Box>
                  <Typography sx={{ fontSize: "14px", mt: 2 }}>
                    Pricing
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      onChange={(e) => setPrice(e.target.value)}
                      value={price}
                      variant="filled"
                      placeholder="Price (INR)"
                      sx={{ mt: 1, width: "30%" }}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          borderRadius: "8px",
                          background: "#E5E5E5",
                        },
                      }}
                      InputLabelProps={{
                        style: { color: "rgba(0,0,0,0.6)" },
                      }}
                      inputProps={{
                        style: {
                          padding: "16px",
                          fontSize: "17px",
                          fontWeight: 400,
                          lineHeight: "24px",
                        },
                      }}
                    />
                    <TextField
                      onChange={(e) => setDiscountedPrice(e.target.value)}
                      value={discountedPrice}
                      variant="filled"
                      placeholder="Discounted Price (INR)"
                      sx={{ mt: 1, width: "30%", ml: 3 }}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          borderRadius: "8px",
                          background: "#E5E5E5",
                        },
                      }}
                      InputLabelProps={{
                        style: { color: "rgba(0,0,0,0.6)" },
                      }}
                      inputProps={{
                        style: {
                          padding: "16px",
                          fontSize: "17px",
                          fontWeight: 400,
                          lineHeight: "24px",
                        },
                      }}
                    />
                    {price !== "" && discountedPrice !== "" ? (
                      <Typography sx={{ ml: 2 }}>
                        {(((price - discountedPrice) / price) * 100).toFixed(2)}
                        % Off
                      </Typography>
                    ) : null}
                  </Box>
                </Box>
              )}

              <Typography
                sx={{ fontSize: "14px", color: "primary.black", mt: 2 }}
              >
                {t("eventModal.eventlink")}
              </Typography>
              <ModalTextfield
                value={externalEventLink}
                setValue={setExternalEventLink}
                inputProp={{ maxLength: 1024 }}
              />
              <Typography
                sx={{ fontSize: "14px", color: "primary.black", mt: 2 }}
              >
                {t("eventModal.description")}
              </Typography>

              <ModalTextfield
                value={description}
                setValue={setDescription}
                inputProp={{ maxLength: 1000 }}
                multiline={true}
                rows={3}
              />
            </Box>
          </Box>
          <DoneButton
            backMethod={closeModal}
            type="submit"
            disabled={
              eventName === "" ||
              timezone === "" ||
              startDate === null ||
              startTime === "" ||
              (eventType === "in-person" && !address)
                ? true
                : false
            }
          />
        </form>
      </Box>
    </>
  );
};

export default EventModal;
